export default __webpack_public_path__ + "static/media/otp-screen.ee7a8b38.svg";